import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson14: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson13"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">Trading Taxes</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson15"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[9.63rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Understanding Crypto Taxes</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  How is Crypto taxed in the U.S.? Your guide to the 2021-2022
                  tax season
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  From laser eyes to all-time-highs, 2021 was quite a year for
                  cryptocurrencies. More than 10 percent of Americans traded
                  crypto in the last year — if you're one of them, you're
                  probably wondering how your trades and other crypto activity
                  will impact your taxes.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  U.S. taxpayers are required to report crypto sales,
                  conversions, payments, and income to the IRS, and state tax
                  authorities where applicable, and each of these transactions
                  has different tax implications. In this article, you'll learn
                  when your crypto is taxed and how your activity might affect
                  your taxes. Let's dive in.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>First things first...</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Coinbase doesn’t provide tax advice. This article represents
                  our stance on IRS guidance received to date, which may
                  continue to evolve and change. None of this should be
                  considered as advice or an individualized recommendation, but
                  it’s important to us that our readers have relevant
                  information available to them in the most accessible way
                  possible. Please consult a tax professional regarding your own
                  tax circumstances.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Do I Owe Crypto Taxes?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  In the U.S., crypto is considered a digital asset, and the IRS
                  treats it generally like stocks, bonds, and other capital
                  assets. Like these assets, the money you gain from crypto is
                  taxed at different rates, either as capital gains or as
                  income, depending on how you got your crypto and how long you
                  held on to it.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>{`To understand if you owe taxes, it’s important to look at how you `}</span>
                <i className="font-dm-sans">used</i>
                <span className="font-dm-sans">{` your crypto in 2021. Transactions that result in a tax are called `}</span>
                <b className="font-dm-sans">taxable events</b>
                <span className="font-dm-sans">{`. Those that don’t are called `}</span>
                <b className="font-dm-sans">non-taxable events.</b>
                <span className="font-dm-sans"> Let’s break them down:</span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b className="font-dm-sans">
              <span className="text-[1.88rem]">
                <span className="text-white">Not Taxable</span>
              </span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="font-dm-sans">
                <span className="text-[1.88rem]">&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    Buying crypto with cash and holding it:
                  </b>
                  <span className="font-dm-sans">
                    {" "}
                    Just buying and owning crypto isn’t taxable on its own. The
                    tax is often incurred later on when you sell, and its gains
                    are “realized.”
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    Donating crypto to a qualified tax-exempt charity or
                    non-profit:
                  </b>
                  <span>{` If you give crypto directly to a 501(c)(3) charitable organization, like `}</span>
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="http://GiveCrypto.org"
                target="_blank"
              >
                <span>
                  <span>
                    <span>
                      <span className="[text-decoration:underline]">
                        GiveCrypto.org
                      </span>
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  <span>
                    , you may be able to claim a charitable deduction.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Receiving a gift:</b>
                  <span className="font-dm-sans">
                    {" "}
                    If you’re lucky enough to get crypto as a gift, you’re not
                    likely to incur a tax until you sell or participate in
                    another taxable activity like staking.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Giving a gift:</b>
                  <span className="font-dm-sans">
                    {" "}
                    How thoughtful! You can gift up to $15,000 per recipient per
                    year without paying taxes (and higher amounts to spouses).
                    If your gift exceeds $15,000 per recipient, you’ll need to
                    file a gift tax return (which generally does not result in
                    any current tax liability). If you transfer crypto to
                    someone else outside of a purchase for goods or services, it
                    may count as a gift, even if you didn’t mean it that way.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">
                    Transferring crypto to yourself:
                  </b>
                  <span className="font-dm-sans">
                    {" "}
                    Transferring crypto between wallets or accounts you own
                    isn’t taxable. You can transfer over your original cost
                    basis and date acquired to continue tracking your potential
                    tax impact for when you eventually sell.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Taxable As Capital Gains</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Selling crypto for cash:</b>
                  <span>
                    {" "}
                    Did you sell your crypto for U.S. dollars? You’ll owe taxes
                    if you sell your assets for more than you paid for them. If
                    you sell at a loss, you may be able to deduct that loss on
                    your taxes.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Converting one crypto to another: `}</b>
                  <span>
                    When you use bitcoin to buy ether, for example, you
                    technically have to sell your bitcoin before you buy a new
                    asset. Because this is a sale, the IRS considers it taxable.
                    You’ll owe taxes if you sold your bitcoin for more than you
                    paid for it.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b>{`Spending crypto on goods and services: `}</b>
                  <span>
                    If you use bitcoin to buy a pizza, for example, you’ll
                    likely owe taxes on the transaction. To the IRS, spending
                    crypto isn’t that much different from selling it. You need
                    to sell the asset before it can be exchanged for a good or
                    service, and selling crypto makes it subject to capital
                    gains taxes.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Taxable As Capital Gains</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Selling crypto for cash:</b>
                  <span>
                    {" "}
                    Did you sell your crypto for U.S. dollars? You’ll owe taxes
                    if you sell your assets for more than you paid for them. If
                    you sell at a loss, you may be able to deduct that loss on
                    your taxes.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Converting one crypto to another: `}</b>
                  <span>
                    When you use bitcoin to buy ether, for example, you
                    technically have to sell your bitcoin before you buy a new
                    asset. Because this is a sale, the IRS considers it taxable.
                    You’ll owe taxes if you sold your bitcoin for more than you
                    paid for it.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b>{`Spending crypto on goods and services: `}</b>
                  <span>
                    If you use bitcoin to buy a pizza, for example, you’ll
                    likely owe taxes on the transaction. To the IRS, spending
                    crypto isn’t that much different from selling it. You need
                    to sell the asset before it can be exchanged for a good or
                    service, and selling crypto makes it subject to capital
                    gains taxes.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b className="font-dm-sans">
              <span className="text-[1.88rem]">
                <span className="text-white">Taxable As Income</span>
              </span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="font-dm-sans">
                <span className="text-[1.88rem]">&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Getting paid in crypto: `}</b>
                  <span className="font-dm-sans">
                    NFL offensive tackle Russell Okung was one of a few big
                    names to take their paychecks in bitcoin in 2021 — and he’s
                    likely paying income tax on it. If you followed Okung’s lead
                    and were paid in crypto by an employer, your crypto will be
                    taxed as compensation according to your income tax bracket.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    Getting crypto in exchange for goods or services:
                  </b>
                  <span className="font-dm-sans">
                    {" "}
                    If you accept crypto in payment for a good or service,
                    you’re responsible for reporting it as income to the IRS.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Mining crypto: `}</b>
                  <span className="font-dm-sans">
                    If you mined crypto, you’ll likely owe taxes on your
                    earnings based on the fair market value (often the price) of
                    the mined coins at the time they were received. Crypto mined
                    as a business is taxed as self-employment income.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Earning staking rewards:</b>
                  <span className="font-dm-sans">
                    {" "}
                    Staking rewards are treated like mining proceeds: taxes are
                    based on the fair market value of your rewards on the day
                    you received them.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Earning other income: `}</b>
                  <span className="font-dm-sans">
                    You might earn a return by holding certain cryptocurrencies.
                    This is considered taxable income. Although this is
                    sometimes referred to as interest, the IRS treats it
                    differently than interest you'd earn from a bank.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    Getting crypto from a hard fork:
                  </b>
                  <span className="font-dm-sans">
                    {" "}
                    Taxes on crypto you got from a hard fork depend on how you
                    use the asset, when it’s available to withdraw from your
                    exchange, and more. See the latest IRS guidance on hard
                    forks.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Getting an airdrop:</b>
                  <span className="font-dm-sans">
                    {" "}
                    You might receive airdrops from a crypto company as part of
                    a marketing campaign or giveaway. Getting an airdrop is
                    taxable as income, and you’ll need to report the amount in
                    your taxes. See the latest IRS guidance on airdrops.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">{`Receiving other incentives or rewards: `}</b>
                  <span>{`This list isn’t comprehensive — there are a variety of reasons why you might receive free crypto. These can include rewards from `}</span>
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.coinbase.com/earn"
                target="_blank"
              >
                <span>
                  <span>
                    <span>
                      <span className="[text-decoration:underline]">
                        Coinbase Earn
                      </span>
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  <span>
                    {" "}
                    or incentives like getting $5 in bitcoin for referring a
                    friend to a crypto exchange. Regardless, you’ll need to
                    report these as income.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Good News For Hodlers</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                If you’re holding crypto, there’s no immediate gain or loss, so
                the crypto is not taxed. Tax is only incurred when you sell the
                asset, and you subsequently receive either cash or units of
                another cryptocurrency: At this point, you have “realized” the
                gains, and you have a taxable event.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">
                How Much Do I Owe In Crypto Taxes?
              </span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">
                  So it looks like some of your crypto activity is taxable —
                  what now? You can estimate how much you’ll owe in taxes by
                  calculating your income, gains, and losses. Here’s what that
                  means:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Calculating crypto income</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  If you’re a U.S. taxpayer, you’re probably used to seeing your
                  federal and state income tax deducted from your pay stubs. The
                  crypto you receive as income (like mining, staking, and
                  rewards) is also subject to these same income taxes, which
                  often won't be deducted or withheld. When you report your
                  earnings, you’ll generally owe according to the income tax
                  rate appropriate to your tax bracket. Word of caution: If
                  you’ve earned a lot from crypto activity, it might affect what
                  tax bracket you’re in and you may end up paying a higher tax
                  rate on some of your earnings.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>{`Visit `}</span>
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://www.irs.gov/newsroom/irs-provides-tax-inflation-adjustments-for-tax-year-2021"
              target="_blank"
            >
              <span>
                <span>
                  <span>
                    <span className="[text-decoration:underline]">IRS.gov</span>
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                <span> for the latest guidance on federal income taxes.</span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Calculating Capital Gains and Losses</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  To calculate the amount you gained or lost, you’ll first need
                  to know how much crypto you started with. This is called your
                </span>
                <b className="font-dm-sans"> cost basis.</b>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Knowing Your Cost Basis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When you buy cryptocurrency, your cost basis is generally
                determined by how much you paid for it. However, if you received
                crypto from mining or staking, your cost basis is determined by
                the fair market value when you received it. Your cost basis for
                gifted crypto will depend on both the basis the person who
                transferred it to you had and the fair market value when you
                received it.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When you sell your crypto, you can subtract your cost basis from
                your sale price in order to figure out whether you have a
                capital gain or capital loss. If your proceeds exceed your cost
                basis, you have a capital gain. If not, you have a capital loss.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Short-Term vs. Long-Term Capital Gains</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">
                  Capital gains taxes are applied at both the federal and state
                  (where applicable) level. They can be
                </span>
                <b className="font-dm-sans"> long-term or short-term,</b>
                <span>
                  {" "}
                  and how long you’ve held your crypto affects how much tax
                  you’ll end up owing. If you held onto your crypto for more
                  than a year before selling, you'll generally pay a lower rate
                  than if you sold right away.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    Long-term gains are taxed at a reduced capital gains rate.
                  </b>
                  <span>
                    {" "}
                    These rates (0%, 15%, or 20% at the federal level) vary
                    based on your income. Higher income taxpayers may also be
                    subject to the 3.8% Net Investment Income Tax on their gains
                    or other income.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    Short-term gains are taxed at your ordinary income rate,
                  </b>
                  <span> which is usually a higher, less-favorable rate.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Remember, taxable events happen when you realize losses or
                  gains, meaning you’ve sold your crypto by either selling for
                  cash, converting to another crypto, or spending it on a good
                  or service. The gains are unrealized if you still own the
                  original shares.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Understanding Your Capital Losses</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                You’ve realized a capital loss when you sold an asset for less
                than you paid for it. Losses can work to your advantage, though.
                You can use losses to offset other capital gains (including from
                non-crypto assets, like stocks) you may have had during the year
                on a dollar-for-dollar basis, potentially reducing your overall
                tax bill.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you have more losses than gains or have no gains at all, the
                maximum amount of losses that you can declare each year to
                offset other income is $3,000. Any remainder carries over to
                subsequent years until the full amount of the loss is applied.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Coinbase Gain/Loss Report</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This tax season, Coinbase customers will be able to generate a
                Gain/Loss Report that details capital gains or losses using a
                HIFO (highest in, first out) cost basis specification strategy.
                This report is designed to help taxpayers quickly and easily
                understand their gains or losses for the tax year, using our
                calculations. The report will only have information about
                activity on Coinbase. It won’t have information about
                crypto-related transactions outside of Coinbase. It’s important
                to review and verify the information for accuracy before you use
                it to file. The tool should not be used as official tax
                documentation. For more on Coinbase Reports and IRS forms, read
                our article
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://www.coinbase.com/learn/your-crypto/tax-documents-explained"
              target="_blank"
            >
              <span>
                <span>
                  <span className="[text-decoration:underline]">
                    : Tax forms, explained
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>.</span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson15">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center max-md:pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson14;


// kdkd